<script>
  import { createPopper } from "@popperjs/core";
  import { onMount, onDestroy } from "svelte";
  import { authStore, initializeAuth } from '../../lib/authStore.js';
  import { get } from 'svelte/store';
  import { navigate } from "svelte-routing"; // Asegúrate de importar 'navigate' para redirigir
  import pb from '../../lib/pocketbase';
  import { POCKETBASE_URL } from '../../config';

  let dropdownPopoverShow = false;
  let btnDropdownRef;
  let popoverDropdownRef;
  let userData = null;
  let imagePath = `${POCKETBASE_URL}/api/files/_pb_users_auth_/`;
  
  const toggleDropdown = (event) => {
    event.preventDefault();
    dropdownPopoverShow = !dropdownPopoverShow;
    if (dropdownPopoverShow) {
      createPopper(btnDropdownRef, popoverDropdownRef, {
        placement: "bottom-start",
      });
    }
  };

  onMount(async () => {
    await initializeAuth();
    const user = localStorage.getItem("pb_user"); // Replace with your token key

    //const { authData } = get(authStore);
    let authData = JSON.parse(user);
    if (authData) {
      userData = authData;
      imagePath += userData.id + "/" + userData.avatar + "?thumb=100x100";
    }

    subscribeToRealtime();
  });


  async function subscribeToRealtime() {
    await pb.collection('users').subscribe('*', (e) => {
      if (e.action === 'update') {
        userData = e.record;
        imagePath = `${POCKETBASE_URL}/api/files/_pb_users_auth_/r8ne6ddgbvpx7dp/${e.record.avatar}?thumb=100x100`;
        console.log('Realtime User avatar:', imagePath);
      }
    });
  }

  onDestroy(() => {
    pb.collection('users').unsubscribe('*');
  });

  // Función para cerrar sesión
  function logout() {
    localStorage.removeItem('pb_token'); // Eliminar el token
    localStorage.removeItem('pb_user'); // Eliminar el token
    localStorage.removeItem('pocketbase_auth'); // Eliminar el token
    navigate('/auth/login'); // Redirigir a la página de inicio de sesión o inicio
  }
</script>

<div>
  <a
    class="text-blueGray-500 block"
    href="#erpsys"
    bind:this="{btnDropdownRef}"
    on:click="{toggleDropdown}"
  >
    <div class="items-center flex">
      <span
        class="w-12 h-12 text-sm text-white bg-blueGray-200 inline-flex items-center justify-center rounded-full"
      >
        <img
          alt="..."
          class="w-full rounded-full align-middle border-none shadow-lg"
          src="{imagePath}"
        />
      </span>
    </div>
  </a>
  <div
    bind:this="{popoverDropdownRef}"
    class="bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg min-w-48 {dropdownPopoverShow ? 'block':'hidden'}"
  >
    <a
      href="#erpsys" on:click={(e) => e.preventDefault()}
      class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
    >
      Action
    </a>
    <a
      href="#erpsys" on:click={(e) => e.preventDefault()}
      class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
    >
      Another action
    </a>
    <a
      href="#erpsys" on:click={(e) => e.preventDefault()}
      class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
    >
      Something else here
    </a>
    <div class="h-0 my-2 border border-solid border-blueGray-100" />
    <a
      href="#erpsys" on:click={logout}
      class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
    >
      Cerrar sesión
    </a>
  </div>
</div>
